<div class="app-tips" [ngStyle]="{ 'background-color': bgColor, color: txtColor }">
  <mat-icon [ngStyle]="{ color: matIconColor }">{{ matIcon }}</mat-icon>
  <div class="app-tips-content">
    <ng-content></ng-content>
  </div>
</div>
